/**
 * Якоря секций лендинга — единый список для навигации в шапке и для самих секций.
 *
 * Держать id в одном месте, а не строками в двух файлах: иначе переименованная
 * секция тихо превращает пункт меню в ссылку в никуда, и заметить это можно
 * только глазами.
 */
export const LANDING_SECTIONS = [
    {id: "how", label: "Как это работает"},
    {id: "match", label: "Совместимость"},
    {id: "qr", label: "По QR"},
    {id: "places", label: "Куда сходить"},
    {id: "tariffs", label: "Тарифы"},
    {id: "trust", label: "Безопасность"},
] as const;

export type LandingSectionId = (typeof LANDING_SECTIONS)[number]["id"];

/**
 * Прокрутка к секции.
 *
 * `scrollIntoView`, а не переход по якорю: страница отрисована внутри ScrollArea
 * (OverlayScrollbars), у которой собственный вьюпорт — нативный якорь его не
 * двигает. Плавность отключается для тех, кто просил меньше движения.
 */
export function scrollToSection(id: LandingSectionId): void {
    const target = document.getElementById(id);
    if (!target) return;
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    target.scrollIntoView({behavior: reduceMotion ? "auto" : "smooth", block: "start"});
}
